import { PlanTypes } from './plan.model';
import { GiftCardDuration } from './enum/voucher-durations.enum';
import { Coupon } from './coupon.model';

export interface Order {
  planType: PlanTypes | null;
  voucherDuration: GiftCardDuration | null;
  hasFamilyOption: boolean;
  coupon: Coupon | null
}

export enum OrderTypes {
  Subscription = 'subscription',
  Voucher = 'voucher',
  Family = 'family',
}
